<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSicCustomizedDiagramScdResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      with-custom-row-actions-first-column
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <em-button
                                            type="view"
                                            class="btn btn-outline-primary btn-sm"
                                            :disabled="$_notCheckedOne"
                                            customLabel="查看数据"
                                            @click="routeToDiagramView">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="fillTemplate"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="定制图区块"
                                            @click="routeToDiagramEdit(row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="区块编辑"
                                            @click="gotoPieceEdit(row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-font"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="区块字体样式编辑"
                                            @click="routeToDiagramSetting(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author lgq
// Date 2022-02-23 13:53:32

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import {_generateDownloadUrl} from "@/components/LayoutMaps/openLayers/utils/MapUtils";

export default {
    name: "emSicCustomizedDiagramScdListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    mounted() {
        if (this.$store.state.routeStore.content.isRouteBack) {
            this.$refs.emListFilter.doQuery();
            this.$store.dispatch('routeStore/addContentByObj', {isRouteBack: false});
        }
        this.registerInputConfig();
    },
    methods: {
        routeToDiagramEdit(row) {
            this.$store.dispatch('routeStore/addContentByObj', {isRouteBack: true});
            this.$router.push({
                name: 'customizedDiagramEdit',
                params: {
                    mapCode: row.scdCode,
                    mapJson: row.scdGeoJson,
                    imgUrl: _generateDownloadUrl(row.imageAttachmentId)
                }
            })
        },
        gotoPieceEdit(row) {
            this.$store.dispatch('routeStore/addContentByObj', {mapJson: row.scdGeoJson, styleJson: row.scdStyleJson});
            this.$_emGotoMixin_gotoHolderList("emSicCustomizedDiagramPieceCdp",
                {cdpIdDiagramFilter: row.id, diagramNameFilter: row.scdName},
                {cdpIdDiagram: row.id, diagramName: row.scdName}, true,
                {
                    imgUrl: _generateDownloadUrl(row.imageAttachmentId)
                });
        },
        routeToDiagramSetting(row) {
            this.$store.dispatch('routeStore/addContentByObj', {
                imgUrl: _generateDownloadUrl(row.imageAttachmentId),
                mapJson: row.scdGeoJson,
                styleJson: row.scdStyleJson,
                isRouteBack: true
            });
            this.$router.push({name: 'customizedDiagramSetting'});
        },
        routeToDiagramView() {
            let checkedRow = this.checkedRows[0];
            let query = {
                diagramCode: checkedRow.scdCode
            };
            this.$router.push({
                name: 'customizedDiagram',
                query: query
            });
        },
        registerInputConfig() {
            let config = [
                {
                    label: '整体缩放',
                    key: 'zoom',
                    type: 'number'
                },
                {
                    label: '开启拖拽/缩放',
                    key: 'scaleAble',
                    type: 'boolean'
                },
                {
                    label: '不显示背景图片',
                    key: 'imageDisable',
                    type: 'boolean'
                },
                {
                    label: '背景底色',
                    key: 'backgroundColor',
                    type: 'color'
                }
            ];
            this.$store.dispatch('jsonInputConfigStore/registerConfig', {
                entityName: this.modelName,
                fieldName: 'scdStyleJson',
                config: config
            })
        },
    }
};
</script>